import { Outlet, createFileRoute } from '@tanstack/react-router'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

// Layout route para /dashboard/$dashboardId/portais/$portalvalue
// Este arquivo serve como layout para rotas filhas dentro de $portalvalue
// Renderiza o Outlet para rotas filhas
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/portais/$portalvalue',
)({
  component: function PortalDetailLayout() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.PORTAIS} dashboardId={dashboardId}>
        <Outlet />
      </RequireModule>
    )
  },
})
